import { render, staticRenderFns } from "./ChartHeader.vue?vue&type=template&id=0cb4eb6b&scoped=true&"
import script from "./ChartHeader.vue?vue&type=script&lang=js&"
export * from "./ChartHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChartHeader.vue?vue&type=style&index=0&id=0cb4eb6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb4eb6b",
  null
  
)

export default component.exports